import esriLoader from "esri-loader";
import $ from "jquery";
import md5 from 'js-md5'
import {
    MessageBox
} from "element-ui";
import mapConfig from "@/utils/mapConfig";
import {
    GetMapDocToken
} from "../../api/home-api"
import { myConfig } from "../../../static/utils/dtpconfig";

import store from "@/store/index"
//import encryption from "@/utils/encryption";
export default function () {
    return esriLoader
        .loadModules([
            "esri/layers/WebTiledLayer",
            "esri/SpatialReference",
            "esri/geometry/Extent",
            "esri/layers/TileInfo",
            "dojo/_base/declare"
        ], {
            url: mapConfig.gisUrl
        })
        .then(([WebTiledLayer, SpatialReference, Extent, TileInfo, declare]) =>
            declare("GSPTileLayer", WebTiledLayer, {
                constructor(serviceUrl, flag) {
                    if (flag == "emap") {
                        debugger
                        serviceUrl = serviceUrl.replace("https://pro.gispai.com/", myConfig.baseUrl)
                        let o = store.state.eMapData;
                        let layerInfo = {
                            tiledUrl: serviceUrl,
                            DefaultToken: "",
                            Wildcard: "",
                            WKID: mapCoordinate,
                            InitialExtent: o.initExent,
                            TileOriginX: o.TileOriginX,
                            TileOriginY: o.TileOriginY,
                            Lods: JSON.parse(o.Lods),
                            TileType: -2
                        }
                        this.tiledUrl = layerInfo.tiledUrl
                        this.spatialReference = new SpatialReference({
                            wkid: layerInfo.WKID
                        });
                        let minx, miny, maxx, maxy;
                        let extentArray = o.initExent.split(",");
                        minx = parseFloat(extentArray[0]);
                        miny = parseFloat(extentArray[1]);
                        maxx = parseFloat(extentArray[2]);
                        maxy = parseFloat(extentArray[3]);
                        this.initialExtent = (this.fullExtent = new Extent(minx, miny, maxx, maxy, this.spatialReference));
                        this.tileInfo = new TileInfo({
                            rows: 256,
                            cols: 256,
                            dpi: 96,
                            format: "MIXED",
                            compressionQuality: 75,
                            origin: {
                                x: layerInfo.TileOriginX,
                                y: layerInfo.TileOriginY
                            },
                            spatialReference: {
                                wkid: layerInfo.WKID
                            },
                            lods: layerInfo.Lods
                        });
                        this.DefaultToken = layerInfo.DefaultToken
                        this.thirdurl = serviceUrl + "&token=" + store.state.user.Token
                        this.layerInfo = layerInfo

                        this.loaded = true;
                        this.onLoad(this);
                        // console.log(-22, this.tileInfo)
                    } else {
                        this.tiledUrl = serviceUrl;
                        this.servicePath = "";
                        this.thirdurl = "";
                        var serverlen = serviceUrl.indexOf('#/services/')
                        var serverUrl = serviceUrl.substr(0, serverlen) + 'MapServerAPI'
                        var delstrLen = serviceUrl.indexOf('/services/') + 20
                        var str = serviceUrl.substr(delstrLen, serviceUrl.length);
                        var paramsArr = str.split("/");
                        this.mapName = paramsArr[paramsArr.length - 2]; //服务名称
                        let serviceTypeName = paramsArr[paramsArr.length - 1]; //服务类型名称
                        let serviceType = 1; //切片服务
                        if (serviceTypeName == "mapservice") {
                            serviceType = 1;
                        } else if (serviceTypeName == "featureservice") {
                            serviceType = 2;
                        } else if (serviceTypeName == "3dservice") {
                            serviceType = 3;
                        } else if (serviceTypeName == "registrationservice") {
                            serviceType = 4;
                        } else {
                            serviceType = 5;
                        }
                        var arr = paramsArr.slice(0, paramsArr.length - 2);
                        if (arr.length == 0) {
                            this.servicePath = "";
                        } else {
                            this.servicePath = arr.join("*");
                        }
                        var _this = this;
                        let queryParams = {
                            path: this.servicePath,
                            mapName: this.mapName,
                            type: serviceType
                        };
                        if (serverUrl.indexOf("http://server.gispai.com") >= 0)
                            serverUrl = serverUrl.replace("http://server.gispai.com", "https://server.gispai.com")

                        this.serverUrl = serverUrl

                        if (serverUrl.indexOf("server.gispai.com") >= 0 || myConfig.baseUrl.indexOf("https")==-1) {
                            $.ajax({
                                url: serverUrl + '/api/Server/GetSigleService',
                                method: "get",
                                async: false,
                                data: queryParams,
                                dataType: "json",
                                success: function (res) {
                                    let data = res;
                                    var type = data.ServiceBaseInfo.type;
                                    if (type === 1) {
                                        _this.layerInfo = data.LayerInfo;
                                    } else if (type === 2) {
                                        _this.layerInfo = data.FeaturelayerInfo;
                                    } else if (type === 3) {
                                        //_this.layerInfo = data.FeaturelayerInfo;
                                    } else if (type === 4) {
                                        _this.DefaultToken = data.RegistrationServerInfo.DefaultToken
                                        _this.layerInfo = data.RegistrationServerInfo.LayerInfo;
                                        _this.thirdurl = data.RegistrationServerInfo.ServerPath;
                                        if (_this.thirdurl.indexOf('siweiearth') > 0) {
                                            //这里写一下发请求取四维的access_token并修改DefaultToken
                                            _this.DefaultToken = store.state.clientToken

                                        } else {
                                            _this.getToken(data.ServiceBaseInfo.Id)
                                        }
                                        _this.tileServers = data.RegistrationServerInfo.Wildcard;
                                    } else if (type == 5) {
                                        _this.DefaultToken = data.RegistrationServerInfo.DefaultToken
                                        _this.getToken(data.ServiceBaseInfo.Id)
                                        _this.layerInfo = data.RegistrationServerInfo.LayerInfo;
                                        _this.thirdurl = data.RegistrationServerInfo.ServerPath;
                                        _this.tileServers = data.RegistrationServerInfo.Wildcard;

                                    } else {
                                        _this.layerInfo = data.RegistrationServerInfo.LayerInfo;
                                        _this.thirdurl = data.RegistrationServerInfo.ServerPath;
                                    }
                                },
                                error: function (error) {
                                    MessageBox({
                                        type: "warning",
                                        message: error
                                    });
                                }
                            });
                        } else {
                            $.ajax({
                                url: myConfig.baseUrl + "/api/Common/GetHttpRequest",
                                method: "post",
                                async: false,
                                data: {
                                    "": serverUrl +
                                        "/api/Server/GetSigleService?path=" +
                                        this.servicePath +
                                        "&mapName=" +
                                        this.mapName +
                                        "&type=" +
                                        serviceType
                                },
                                dataType: "json",
                                success: function (res) {
                                    let data = res;
                                    var type = data.ServiceBaseInfo.type;
                                    if (type === 1) {
                                        _this.layerInfo = data.LayerInfo;
                                    } else if (type === 2) {
                                        _this.layerInfo = data.FeaturelayerInfo;
                                    } else if (type === 3) {
                                    } else if (type === 4) {
                                        _this.DefaultToken = data.RegistrationServerInfo.DefaultToken
                                        _this.getToken(data.ServiceBaseInfo.Id)
                                        _this.layerInfo = data.RegistrationServerInfo.LayerInfo;
                                        _this.thirdurl = data.RegistrationServerInfo.ServerPath;
                                        _this.tileServers = data.RegistrationServerInfo.Wildcard;

                                    } else if (type == 5) {
                                        _this.DefaultToken = data.RegistrationServerInfo.DefaultToken
                                        _this.getToken(data.ServiceBaseInfo.Id)
                                        _this.layerInfo = data.RegistrationServerInfo.LayerInfo;
                                        _this.thirdurl = data.RegistrationServerInfo.ServerPath;
                                        _this.tileServers = data.RegistrationServerInfo.Wildcard;
                                    }
                                    else {
                                        _this.layerInfo = data.RegistrationServerInfo.LayerInfo;
                                        _this.thirdurl = data.RegistrationServerInfo.ServerPath;
                                    }
                                },
                                error: function (error) {
                                    MessageBox({
                                        type: "warning",
                                        message: error
                                    });
                                }
                            });


                        }
                        //属性
                        this.id = "";
                        this.spatialReference = new SpatialReference({
                            wkid: this.layerInfo.WKID
                        });
                        //this.tileServers = ["t0", "t1", "t2", "t3", "t4", "t5"];
                        var extentstr = this.layerInfo.InitialExtent;
                        var extentarray = extentstr.split(",");
                        this.fullExtent = new Extent(
                            parseFloat(extentarray[0]),
                            parseFloat(extentarray[1]),
                            parseFloat(extentarray[2]),
                            parseFloat(extentarray[3]),
                            new SpatialReference({
                                wkid: this.layerInfo.WKID
                            })
                        );
                        this.initialExtent = this.fullExtent;
                        this.tileInfo = new TileInfo({
                            rows: 256,
                            cols: 256,
                            dpi: 96,
                            format: "MIXED",
                            compressionQuality: 75,
                            origin: {
                                x: this.layerInfo.TileOriginX,
                                y: this.layerInfo.TileOriginY
                            },
                            spatialReference: {
                                wkid: this.layerInfo.WKID
                            },
                            lods: this.layerInfo.Lods
                        });

                        this.loaded = true;
                        this.onLoad(this);
                        // console.log(-33, this.tileInfo)
                    }

                },
                getTileUrl(level, row, column) {
                    var url = "";
                    //    console.log("tileurl",this.thirdurl)
                    if (!this.layerInfo) {
                        url =
                            "https://a.tile.thunderforest.com/cycle/${level}/${col}/${row}.png";
                    } else {
                        if (this.layerInfo.TileType == 4) {
                            url = this.thirdurl
                            if (url.indexOf("baidumap") >= 0) {
                                var zoom = level - 1;
                                var offsetX = parseInt(Math.pow(2, zoom));
                                var offsetY = offsetX - 1;
                                var numX = column - offsetX,
                                    numY = -row + offsetY;
                                var num = ((column + row) % 8) + 1;
                                return (
                                    "http://online" +
                                    num +
                                    ".map.bdimg.com/tile/?qt=tile&x=" +
                                    numX +
                                    "&y=" +
                                    numY +
                                    "&z=" +
                                    level +
                                    "&styles=pl&scaler=1&udt=20180505"
                                );
                            } else if (url.indexOf("{row/16}") >= 0) {
                                row = Math.pow(2, level) - 1 - row
                                url = url.replace("{row/16}", Math.floor(row / 16.0).toString())
                                url = url.replace("{col/16}", Math.floor(column / 16.0).toString())
                            }
                            url = url
                                .replace("{row}", row.toString())
                                .replace("{col}", column.toString())
                                .replace("{level}", level.toString()).replace("{token}", this.DefaultToken);
                            var tileserverArray = this.tileServers.split(",");
                            if (this.thirdurl.indexOf('siweiearth') > 0) {
                                url = url.replace("{access_token}", this.DefaultToken);
                            }
                            url = url.replace(
                                "${domains}",
                                tileserverArray[
                                Math.floor(Math.random() * tileserverArray.length)
                                ]
                            );
                        } else if (this.layerInfo.TileType == 5) {
                            url = myConfig.gspServiceUrl + "/tile.ashx?tiletype=" + this.layerInfo.TileType + "&dir=" + this.mapName + "&path=" + this.servicePath +
                                "&r=" + row + "&c=" + column + "&z=" + level;
                        } else if (this.layerInfo.TileType == -2) {
                            url = this.thirdurl.replace("{Row}", row.toString())
                                .replace("{Col}", column.toString())
                                .replace("{Level}", level.toString()).replace("{token}", this.DefaultToken);
                            // console.log(-2,url)
                        } else {
                            let timestamp = Date.now();
                            let params =
                                "c=" +
                                column +
                                "&dir=" +
                                this.mapName +
                                "&path=" +
                                this.servicePath +
                                "&r=" +
                                row +
                                "&tiletype=" +
                                this.layerInfo.TileType +
                                "&timestamp=" +
                                timestamp +
                                "&z=" +
                                level +
                                "";
                            //let secretkey = encryption.encrypt(params, "12345678", "Rkb4jvUy/ye7Cd7k89QQgQ==");
                            let secretkey = md5(params + "12345678");
                            url = this.serverUrl + "/tile.ashx?" + params + "&secretkey=" + secretkey + "";
                            // url = gspServiceUrl + "/tile.ashx?tiletype=" + this.layerInfo.TileType + "&dir=" + this.mapName + "&path=" + this.servicePath +
                            // "&r=" + row + "&c=" + column + "&z=" + level + "&timestamp=" + timestamp + "&secretkey=" + secretkey + "";
                        }
                    }


                    return url;
                },
                getToken(name) {
                    GetMapDocToken({
                        Name: name
                    }).then(resd => {
                        if (resd.data.Status == 1) {
                            this.DefaultToken = resd.data.Data
                        }
                        // console.log(121, resd)
                    })
                }
            })
        );
}
